// import storage from './storage'
import Fly from 'flyio/dist/npm/fly'
const fly = new Fly()

// const URL = 'https://localhost:4430'
const URL = 'https://pinche.jafron.com'

/**
 * 默认响应内容
 */
const RESULT_DEFAULT = {
    status: 0,
    message: null,
    count: 0,
    data: [],
    success: false
}
/**
 * HTTP请求头（附带企微授权后的 JWT）
 */
const getAuthHeaders = (extra = {}) => {
    const headers = { ...extra }
    const token = localStorage.getItem('access_token')
    if (token) {
        headers.Authorization = 'Bearer ' + token
    }
    return headers
}
const getHeaders = () => {
    return getAuthHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    })
}
const getHeaders_formdata = () => {
    return getAuthHeaders({
        'Content-Type': 'multipart/form-data'
    })
}



/**
 * 处理响应内容
 * @param response
 * @returns {*}
 */
async function formatResponse(response) {
    let result = null
    if (response.status === 200) {
        result = response.data
        if (!result.success) {
            if (result.code === 500) {
                result = Object.assign({}, RESULT_DEFAULT, { message: '系统错误' })
            } else if (result.code === 501) {
                result = Object.assign({}, RESULT_DEFAULT, { message: '签名校验失败' })
            } else if (result.code === 502) {
                result = Object.assign({}, RESULT_DEFAULT, { message: '接口超时' })
            }
        }
    } else if (response.status === 500) {
        result = Object.assign({}, RESULT_DEFAULT, { message: '系统错误' })
    } else {
        result = Object.assign({}, RESULT_DEFAULT, { message: response.statusText })
    }

    return Object.assign({}, RESULT_DEFAULT, result)
}

export async function request({ url, method, params = {}, data = {} }) {
    try {
        const response = await fly.request(
            URL + url,
            data,
            {
                method: method || 'get',
                headers: getHeaders(),
                params: params || {}
            }
        )
        // console.log('response', response)
        // if (response.data.code === 200 && response.data.success) {
        //     return await formatResponse(response.data.data)
        // } else {
        //     console.log('调用失败')
        //     this.$toast(response.data.message)
        // }
        return await formatResponse(response)
    } catch (e) {
        console.log('error', e)
        const status = e && e.response && e.response.status
        if (status === 401) {
            localStorage.removeItem('access_token')
            return Object.assign({}, RESULT_DEFAULT, {
                message: '登录已失效，请重新进入应用',
                code: 401
            })
        }
        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误,' + (e.message || '') })
    }
}


/**
 * GET
 * @param url
 * @param params
 * @param data
 * @returns {*}
 * @constructor
 */
// eslint-disable-next-line no-unused-vars
export async function GET({ url, params = {}, data = {} }) {
    try {
        const response = await fly.request(url, params, {
            method: 'get',
            headers: getHeaders()
        })
        return await formatResponse(response)
    } catch (e) {
        console.log(e)
        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误' })
    }
}

/**
 * POST
 * @param url
 * @param params
 * @param data
 * @constructor
 */
export async function POST({ url, params = {}, data = {} }) {
    try {
        const response = await fly.request(url, data, {
            method: 'post',
            headers: getHeaders(),
            params: params
            // body: encrypt(JSON.stringify(data)
        })
        // axios({
        //   method: 'post',
        //   url: url,
        //   data: data
        // })
        return await formatResponse(response)
    } catch (e) {
        console.log(e)

        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误' })
    }
}


/**
 * PUT
 * @param url
 * @param params
 * @param data
 * @constructor
 */
export async function PUT({ url, params = {}, data = {} }) {
    try {
        const response = await fly.request(url, params, {
            method: 'put',
            headers: getHeaders(),
            // body: encrypt(JSON.stringify(data))
            body: JSON.stringify(data)
        })
        return await formatResponse(response)
    } catch (e) {
        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误' })
    }
}

/**
 * DELETE
 * @param url
 * @param params
 * @returns {*}
 * @constructor
 */
export async function DELETE({ url, params = {}, data = [] }) {
    console.log(url)
    try {
        const response = await fly.request(url, params, {
            method: 'delete',
            headers: getHeaders(),
            body: JSON.stringify(data)
        })
        return await formatResponse(response)
    } catch (e) {
        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误' })
    }
}


/**
 * FILE
 * @param url
 * @param params
 * @param data
 * @constructor
 */
 export async function FILE({ url, params = {}, data = {} }) {
    try {
        const response = await fly.request(url, data, {
            method: 'post',
            headers: getHeaders_formdata(),
            params: params
            // body: encrypt(JSON.stringify(data)
        })
        return await formatResponse(response)
    } catch (e) {
        console.log(e)
        return Object.assign({}, RESULT_DEFAULT, { message: '发生未知的网络错误' })
    }
}